<template>
    <div>
      <!-- <OwnerDetails /> -->
    </div>
    <v-row class="bottom-section">
      <!-- <PersonList :listName="'Salesperson'" :icon="'account-arrow-right-outline'" :list="salespersons"/>
      <PersonList :listName="'Production Owners'" :icon="'factory'" :list="salespersons"/> -->
        <v-col cols="12" md="3" xs="12">
            <v-text-field
            label=""
            v-model="name"
            placeholder="Enter your name"
            outlined
            ></v-text-field>
        </v-col >
        <v-col cols="12" md="3" xs="12">
            <v-text-field
            label=""
            v-model="name"
            placeholder="Enter your name"
            outlined
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" xs="12">
            <v-text-field
            label=""
            v-model="name"
            placeholder="Enter your name"
            outlined
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" xs="12">
            <v-text-field
            label=""
            v-model="name"
            placeholder="Enter your name"
            outlined
            ></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col class="text-container" cols="12" md="12" xs="12">
            <textarea class="create-cl-details" name="comments" id="" aria-hidden="true"></textarea>
        </v-col>
        <v-col class="btns">
            <v-btn>Cancel</v-btn>
            <v-btn>Save</v-btn>
        </v-col> 
    </v-row>
    <v-row >
        
    </v-row>
  </template>
  
  <script>
  // import OwnerDetails from "./OwnerDetails.vue";
  // import ProductionOwners from "./ProductionOwners.vue";
//   import PersonList from "../ClientDetails/PointOfContanct/PersonList.vue";
  export default {
    components: {
      // OwnerDetails,
    //   PersonList,
      // ProductionOwners,
    },
    data() {
      return {
        salespersons: [
        //   {
        //     code: "ABR",
        //     name: "Abraham D Cohen",
        //     first_name:"Abraham",
        //     last_name:"Cohen",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Aaron F Harari",
        //     first_name:"Aaron",
        //     last_name:"Harari",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   { code: "ABR", name: "Baruk",first_name:"Baruk",
        //   last_name:"", email: "abraham@creativebrandsllc.com" },
        //   {
        //     code: "ABR",
        //     name: "Jack Cohen",
        //     first_name:"Jack",
        //     last_name:"Cohen",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Joe Chera",
        //     first_name:"Joe",
        //     last_name:"Chera",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Steven Cohen",
        //     first_name:"Steven",
        //     last_name:"Cohen",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Kenneth Tawil",
        //     first_name:"Kenneth",
        //     last_name:"Tawil",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Abraham D Cohen",
        //     first_name:"Abraham",
        //     last_name:"Cohen",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Aaron F Harari",
        //     first_name:"Aaron",
        //     last_name:"Harari",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   { code: "ABR", name: "Baruk",first_name:"Baruk",
        //   last_name:"", email: "abraham@creativebrandsllc.com" },
        //   {
        //     code: "ABR",
        //     name: "Jack Cohen",
        //     first_name:"Jack",
        //     last_name:"Cohen",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Joe Chera",
        //     first_name:"Joe",
        //     last_name:"Chera",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Steven Cohen",
        //     first_name:"Steven",
        //     last_name:"Cohen",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        //   {
        //     code: "ABR",
        //     name: "Kenneth Tawil",
        //     first_name:"Kenneth",
        //     last_name:"Tawil",
        //     email: "abraham@creativebrandsllc.com",
        //   },
        ],
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .btns{
    display: flex;
    gap: 20px;
    justify-content: end;
  }
  .text-container{
    height: 150px;
  }
  .create-cl-details{
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .bottom-section {
    margin-top: 1rem;
    // display: grid;
    // grid-template-columns: repeat(4, 1fr);
    // gap: 1rem;
    // align-items: start;
  
    @media (max-width: 768px) { 
      grid-template-columns: repeat(2, 1fr);
    }
  
    @media (max-width: 480px) { 
      grid-template-columns: 1fr;
    }
  }
  
  
  </style>
  